var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEquestrianSports = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Sport-Horse-Riding--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Sport Horse Riding Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 5.31a0.25 0.25 0 0 0 -0.25 0.25v0.18a2.5 2.5 0 1 0 5 0v-0.18a0.25 0.25 0 0 0 -0.25 -0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.35 19.16 0.87 -1.91a0.5 0.5 0 0 0 -0.17 -0.41L4 15.09a2.53 2.53 0 0 1 -0.64 -0.88 0.25 0.25 0 0 0 -0.31 -0.14 4.49 4.49 0 0 0 -3 4.24v3.5a0.5 0.5 0 0 0 0.5 0.5h5.08a0.25 0.25 0 0 0 0.23 -0.15 0.25 0.25 0 0 0 -0.05 -0.27 2.5 2.5 0 0 1 -0.46 -2.73Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.53 12.17 20.13 10V8.53a0.63 0.63 0 0 0 -0.31 -0.53 0.64 0.64 0 0 0 -0.64 0 21.1 21.1 0 0 0 -3.93 3.38 0.3 0.3 0 0 0 -0.06 0.2 0.32 0.32 0 0 0 0.1 0.18l1.13 0.79a2.5 2.5 0 0 1 -2.53 4.31s-2.17 -1.52 -2.17 -1.52a5.61 5.61 0 0 1 -0.8 -0.58 0.27 0.27 0 0 0 -0.31 0 0.26 0.26 0 0 0 -0.09 0.29 7.3 7.3 0 0 1 0.49 3.7 3.42 3.42 0 0 1 -0.13 0.34l-1 2.15a2.19 2.19 0 0 1 -0.45 0.67 0.26 0.26 0 0 0 0 0.27 0.25 0.25 0 0 0 0.23 0.15h7.84a0.5 0.5 0 0 0 0.5 -0.5v-1.5a10.47 10.47 0 0 1 1.89 -5.94l2.08 0.38a1.49 1.49 0 0 0 1.66 -0.61s0.31 -0.77 0.31 -0.77a1 1 0 0 0 -0.41 -1.22Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 20.81s1 -2.29 1.05 -2.36a4.52 4.52 0 0 0 -1.4 -4.65L8 13.23l2 -1.63 0.33 0.76a4.52 4.52 0 0 0 1.9 2.13L14.39 16a1.51 1.51 0 0 0 0.74 0.19 1.5 1.5 0 0 0 0.75 -2.8l-2.13 -1.5a1.45 1.45 0 0 1 -0.63 -0.71L12 8.6A1.5 1.5 0 0 0 9.7 8l-5 4a1.52 1.52 0 0 0 -0.57 1.15 1.5 1.5 0 0 0 0.53 1.16l2 1.75a1.5 1.5 0 0 1 0.48 1.46l-0.91 2A1.5 1.5 0 1 0 9 20.81Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 4.31a0.5 0.5 0 1 0 0 -1h-1.21a3 3 0 0 0 -1.85 -1.51 3 3 0 0 0 -3.61 1.83 0.5 0.5 0 0 0 0.05 0.46 0.5 0.5 0 0 0 0.41 0.22Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEquestrianSports);
export default ForwardRef;